import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import ProductCard from "./Refine/ProductCard";
import { useTranslation } from "react-i18next";
import "swiper/css";
import "swiper/css/navigation";

const NewArrivalTwo = ({ related }) => {
  const { t } = useTranslation();

  return (
    <section className="new-arrival bg-white pb-80">
      <div className="container container-lg">
        {/* Section Header */}
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">{t("youMightAlsoLike")}</h5>
            <div className="flex-align mr-point gap-16">
              <Link
                to="/products"
                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
              >
                {t("allProducts")}
              </Link>
            </div>
          </div>
        </div>

        {/* Swiper Slider */}
        <div className="new-arrival__slider arrow-style-two">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={6}
            autoplay={{ delay: 3000 }}
            speed={1000}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            loop={true}
            breakpoints={{
              1599: { slidesPerView: 5 },
              1399: { slidesPerView: 4 },
              992: { slidesPerView: 3 },
              575: { slidesPerView: 2 },
              424: { slidesPerView: 1 },
            }}
          >
            {related.map((product) => (
              <SwiperSlide key={product._id}>
                <ProductCard item={product} className="col-12" />
              </SwiperSlide>
            ))}

            {/* Navigation Buttons */}
            <div className="swiper-button-next custom-arrow">
              <i className="ph ph-caret-right"></i>
            </div>
            <div className="swiper-button-prev custom-arrow">
              <i className="ph ph-caret-left"></i>
            </div>
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default NewArrivalTwo;
